import { ACCESS_LOADING, ACCESS_SUCCESS, ACCESS_FAIL } from "../constants/actionTypes";
import { fetchAccess as fetchAccessAPI } from "../api"; // adjust path if your api file is elsewhere

export const fetchAccess = () => async (dispatch) => {

  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  if (process.env.REACT_APP_LOCAL_BYPASS === "true" && isLocalhost) {
    const { data } = await fetchAccessAPI();
    dispatch({
      type: ACCESS_SUCCESS,
      payload: data
    });
    return { hasUser: true, isSubscribed: true };
  }


  dispatch({ type: ACCESS_LOADING });

  try {
    const { data } = await fetchAccessAPI();

    dispatch({
      type: ACCESS_SUCCESS,
      payload: data,
    });
    console.log(data);
    
    return data;
  } catch (error) {
    dispatch({
      type: ACCESS_FAIL,
      payload: {
        error: error?.response?.data?.message || error?.message || "ACCESS_FAIL",
      },
    });
    return null;
  }
};
